import { styled } from 'styletron-react';

export default styled('div', () => ({
  width: '100%',
}));
